import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from './index'
import { SidePanelContent, ReadMoreData } from './types'
import { ReadMoreEntry } from '../components/SidePanels/ContentReadMore'

export interface SidePanelState {
  readMoreNode: ReadMoreEntry | null
  readMoreData: ReadMoreData | null
  gvSidePanelOpen: boolean
  gvSidePanelContent: SidePanelContent | null
}

const initialState: SidePanelState = {
  readMoreNode: null,
  readMoreData: null,
  gvSidePanelOpen: false,
  gvSidePanelContent: null,
}

export const sidePanelSlice = createSlice({
  name: 'sidePanel',
  initialState,
  reducers: {
    setReadMoreNode: (state, action: PayloadAction<ReadMoreEntry | null>) => {
      state.readMoreNode = action.payload
    },
    setReadMoreData: (state, action: PayloadAction<ReadMoreData | null>) => {
      state.readMoreData = action.payload
    },
    openGvPanel: (state) => {
      state.gvSidePanelOpen = true
    },
    closeGvPanel: (state) => {
      state.gvSidePanelOpen = false
    },
    setGvSidePanelContent: (
      state,
      action: PayloadAction<SidePanelContent | null>,
    ) => {
      state.gvSidePanelContent = action.payload
    },
  },
})

export const {
  setReadMoreNode,
  setReadMoreData,
  openGvPanel,
  closeGvPanel,
  setGvSidePanelContent,
} = sidePanelSlice.actions

export const getSidePanelState = (state: RootState) => state.sidePanel

export default sidePanelSlice.reducer
